module.exports = __webpack_public_path__ + "5ea05426a74bce46869f6ed2616ceca9.jpg";